import React from "react";
import { TextField , FormHelperText } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const CustomDateTimePicker = ({
  label = "Date/Time",
  width = "unset",
  inputwidth = 300,
  background = "transparent",
  dateValue,
  name,
  formik,
}) => {

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label={label}
        value={dateValue}
        onChange={(newValue) => {
          formik.setFieldValue(name,newValue)
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              sx={{
                marginBottom:"15px",
                width: width,
                background: background,
                ".MuiFormLabel-root": { color: "#50566E" },
                "& .MuiInputBase-root": {
                  width: inputwidth,
                  fontWeight:"bold",
                  color: "var(--secondary)",
                  "& fieldset": {
                    borderColor: "#D3D8E3",
                  },
                  "&:hover fieldset": {
                    borderColor: "#D3D8E3",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#D3D8E3",
                  },
                  "& .MuiOutlinedInput-input":{
                    padding:"10px 0px 10px 5px"
                  }
                },
              }}
              size="small"
            />
          );
        }}
      />
       {formik?.errors[name] && (
        <FormHelperText sx={{ color: "#d32f2f" , position:"absolute" }}>
                  {formik?.errors[name]}
            </FormHelperText>
               )}
    </LocalizationProvider>
  );
};

export default CustomDateTimePicker;
